import React from 'react';
import { getPayTypesFromJob } from 'utils/fieldglass';

import { Grid, Typography } from '@mui/material';

import { Job } from '@libs/graphql-types';
import { modelPath } from '@libs/helpers/form';
import { ConnectedSelect } from '@libs/ui/components/form/select';

import { ApplicationFormState } from '../../types';

interface DefaultWorkerPayTypeProps {
  job: Job;
  showOnlyRequired?: boolean;
}

// const DEFAULT_WORKER_PAY_TYPE_OPTIONS = [
//   { text: 'Non_Federal_Recruited', value: 'Non_Federal_Recruited' },
//   { text: 'Non_Federal_Payrolled', value: 'Non_Federal_Payrolled' },
//   { text: 'Federal_Recruited', value: 'Federal_Recruited' },
//   { text: 'Federal_Payrolled', value: 'Federal_Payrolled' },
//   { text: 'Rapid_Response_Recruited', value: 'Rapid_Response_Recruited' },
// ];

/**
 * Default Worker Pay Type form component
 * This component renders the standard worker pay type form for most job applications
 * using the standard worker pay type options
 */
export const DefaultWorkerPayType: React.FC<DefaultWorkerPayTypeProps> = ({
  job,
  showOnlyRequired = false,
}) => {
  const payRates = getPayTypesFromJob(job, 'ST').map((i) => ({
    text: i,
    value: i,
  }));

  return (
    <>
      <Grid item>
        <Typography variant="h6" gutterBottom>
          Worker Pay Type Information{' '}
          <Typography component="span" color="error">
            *
          </Typography>
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Please select the appropriate worker pay type for this position.
        </Typography>
      </Grid>

      <Grid item>
        <ConnectedSelect
          name={modelPath<ApplicationFormState>((i) => i.details.workerPayType)}
          options={payRates}
          fullWidth
          hideNoneValue
          variant="filled"
          label={
            <Typography>
              Worker Pay Type{' '}
              <Typography component="span" color="error">
                *
              </Typography>
            </Typography>
          }
        />
      </Grid>
    </>
  );
};
